var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDefaultAvatarDistributionList = function SvgDefaultAvatarDistributionList(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#76CACE",
    d: "M0 0h52v52H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.653 19.378a.652.652 0 0 1-.6-.418.7.7 0 0 1 .346-.9l6.743-3.006a.643.643 0 0 1 .858.365.7.7 0 0 1-.347.9l-6.745 3.005a.602.602 0 0 1-.255.054M41.36 24.243h-.006l-7.72-.093c-.353-.004-.638-.312-.634-.69.005-.377.309-.68.647-.676l7.72.093c.353.005.638.312.633.69-.003.375-.288.676-.64.676M40.398 32.19a.615.615 0 0 1-.255-.056l-6.744-3.005a.7.7 0 0 1-.347-.9.645.645 0 0 1 .858-.364l6.744 3.005a.7.7 0 0 1 .347.9.658.658 0 0 1-.603.42"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 1.053,
    d: "M29.835 34.129c.646.315 1.165.004 1.165-.703V15.822c0-.704-.52-1.013-1.165-.7 0 0-8.693 4.55-15.243 4.55-1.576 0-3.592 2.083-3.592 4.928 0 2.845 2.004 4.957 3.592 4.957.787 0 2.612.208 2.612.208v7.076c0 1.17.969 2.12 2.163 2.12 1.195 0 2.164-.95 2.164-2.12v-6.076c4.347 1.351 8.304 3.364 8.304 3.364z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDefaultAvatarDistributionList);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/default-avatar--distributionList.ac9e7e2bf9dde652eebbfae57c497a5f.svg";